import Calendar from 'react-calendar';
import { formatInternalDate } from '~/lib/DateTime.js';
import useWeekStart from '~/lib/useWeekStart.js';

const MonthlyAvailabilityMiniCal = ({
    selectedDate,
    setSelectedDate,
    canSelectAnyDate,

    tileDisabled,
    tileClassName,

    setView,
    viewActiveDate,
    updateActiveStart,
}) => {
    const weekStart = useWeekStart();

    return (
        <div className="availability-picker__calendar inline-block align-top mb-2">
            <Calendar
                onChange={setSelectedDate}
                goToRangeStartOnSelect={false}
                calendarType={weekStart === 0 ? 'gregory' : 'iso8601'}
                value={selectedDate}
                showFixedNumberOfWeeks={true}
                minDate={canSelectAnyDate ? null : new Date()}
                activeStartDate={viewActiveDate}
                onActiveStartDateChange={({
                    action,
                    activeStartDate,
                    value,
                    view,
                }) => {
                    updateActiveStart(activeStartDate);
                    setView(view);
                }}
                tileDisabled={tileDisabled}
                tileClassName={tileClassName}
            />
        </div>
    );
};

export default MonthlyAvailabilityMiniCal;
